import {
  GAME_FROM,
  GAME_TO,
  GAME_FROMTO_VISIBLE,
  GAME_CHOICE,
  GAME_SELF,
  GAME_MULTI,
  GAME_WRITE
} from "../actionTypes";
import _ from "lodash";
import configApp from '../../config';
import axios from 'axios';

// mots     =  tata  tete  titi  toto  tutu
// randoms  =   3     2     4     0     1
// position =   0     1     2     3     4
// result   =  toto  titi  tutu  tata  tete

function shuffle(array) {
  for (let i = array.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

const getNumber = (max, alreadyNumber) => {
  let chose = Math.floor(Math.random() * (max + 1));
  let found = alreadyNumber.find((x) => x === chose);
  if (found !== undefined && alreadyNumber.length < max + 1) {
    return getNumber(max, alreadyNumber);
  } else {
    return chose;
  }
};

const genChoice = (mots, guess) => {
  if (mots && mots.length > 3) {
    let choices = [guess];
    for (let index = 0; index < 3; index++) {
      let choose = getNumber(mots.length - 1, choices);
      choices.push(choose);
    }
    return shuffle(choices);
  }
  return [];
};

const genereRandomNumber = (type) => async (dispatch, getState) => {
  const { mot, game } = getState();
  let { mots, loadingBank, bank } = mot;
  let { from, to, self, multi, write } = game;

  let alreadyNumber = [];

  for (let index = 0; index < mots.length; index++) {
    let chose = getNumber(mots.length - 1, alreadyNumber);
    alreadyNumber.push(chose);
  }

  //fetch the word to find
  let guess = '';
  if (mots && mots.length > 1 && !_.isEmpty(from)) {
    if (loadingBank) {
      const { data } = await axios.post(configApp.URL_BACKEND + "/api/word/game/", { configId: from === 'image' ? 'image' : from._id, wordsIds: [mots[alreadyNumber[0]]._id] });
      guess = _.head(data) ? _.head(data).t : '---';
    } else {
      let word = _.find(bank, function (o) { return o._id === mots[alreadyNumber[0]]._id });
      if (from === 'image') {
        guess = word.image;
      } else {
        let w = _.find(word.names, function (o) { return o.cid === from._id });
        guess = w ? w.t : '---';
      }
    }
  }

  let answer = '';
  if (mots && mots.length > 1 && !_.isEmpty(to)) {
    if (loadingBank) {
      const { data } = await axios.post(configApp.URL_BACKEND + "/api/word/game/", { configId: to._id, wordsIds: [mots[alreadyNumber[0]]._id] });
      answer = _.head(data) ? _.head(data).t : '---';
    } else {
      let word = _.find(bank, function (o) { return o._id === mots[alreadyNumber[0]]._id });
      let w = _.find(word.names, function (o) { return o.cid === to._id });
      answer = w ? w.t : "---";
    }
  }

  let multiChoices = [];
  if (mots && mots.length > 1 && !_.isEmpty(to)) {
    if (loadingBank) {
      let choices = genChoice(mots, alreadyNumber[0]).map(choice => mots[choice]._id);
      const { data } = await axios.post(configApp.URL_BACKEND + "/api/word/game/", { configId: to._id, wordsIds: choices });
      multiChoices = _.shuffle(data);
    } else {
      multiChoices = _.shuffle(genChoice(mots, alreadyNumber[0]).map(choice => mots[choice]._id).map(idMot => {
        let word = _.find(bank, function (o) { return o._id === idMot });
        let t = _.find(word.names, function (o) { return o.cid === to._id });
        return { i: word._id, t: t ? t.t : "---" }
      }));
    }
  }

  if (type === "self") {
    dispatch(
      setSelf({
        randoms: alreadyNumber,
        position: 0,
        solution: false,
        guess: guess,
        answer: answer,
        font: self.font
      })
    );
  } else if (type === "multi") {
    dispatch(
      setMulti({
        randoms: alreadyNumber,
        position: 0,
        solution: false,
        attempt: -1,
        choices: multiChoices,
        guess: guess,
        answer: answer,
        font: multi.font
      })
    );
  } else {
    dispatch(
      setWrite({
        randoms: alreadyNumber,
        position: 0,
        solution: false,
        guess: guess,
        answer: answer,
        font: write.font
      })
    );
  }
};

const selectFromIncrement = () => async (dispatch, getState) => {
  const { config, game } = getState();
  let { from } = game;
  let { configs } = config;

  let configClean = _.orderBy(_.filter(configs, function (o) { return o.type === "word" && o.isEnable !== false }), ['position'], ['asc']);
  let longueur = configClean.length;
  
  if (longueur === 0) return
  
  let index = from ? _.findIndex( configClean , { '_id' : _.get(from, '_id') }) : 0 ;

  if ( index === longueur - 1) {
    dispatch(selectFromWord('image'));
  } else {
    let newFrom = configClean[index + 1 ] ;
    dispatch(selectFromWord(newFrom));
  }
};

const selectToIncrement = () => async (dispatch, getState) => {
  const { config, game } = getState();
  let { to } = game;
  let { configs } = config;

  let configClean = _.orderBy(_.filter(configs, function (o) { return o.type === "word" && o.isEnable !== false  }), ['position'], ['asc']);
  let longueur = configClean.length;

  if (longueur === 0) return

  let index = to ? _.findIndex( configClean , { '_id' : _.get(to, '_id') }) : 0 ;

  let newTo;
  if ( index === - 1) {
    newTo = configClean[0] ;
  } else if ( index === longueur - 1) {
    newTo = configClean[0] ;
  } else {
    newTo = configClean[index + 1 ] ;
  }
  dispatch(selectToWord(newTo));
};

const selectFromDecrement = () => async (dispatch, getState) => {
  const { config, game } = getState();
  let { from } = game;
  let { configs } = config;

  let configClean = _.orderBy(_.filter(configs, function (o) { return o.type === "word" && o.isEnable !== false }), ['position'], ['asc']);
  let longueur = configClean.length;

  if (longueur === 0) return

  let index =  from ? _.findIndex( configClean , { '_id' : _.get(from, '_id') }) : 0 ;

  if ( index === 0) {
    dispatch(selectFromWord('image'));
  } else if (index === -1){
    let newFrom = configClean[ longueur + index] ;
    dispatch(selectFromWord(newFrom));
  } else {
    let newFrom = configClean[index - 1 ] ;
    dispatch(selectFromWord(newFrom));
  }
};

const selectToDecrement = () => async (dispatch, getState) => {
  const { config, game } = getState();
  let { to } = game;
  let { configs } = config;

  let configClean = _.orderBy(_.filter(configs, function (o) { return o.type === "word" && o.isEnable !== false }), ['position'], ['asc']);
  let longueur = configClean.length;

  if (longueur === 0) return

  let index = to ? _.findIndex( configClean , { '_id' : _.get(to, '_id') }) : 0 ;

  let newTo
  if ( index === -1) {
    newTo = configClean[0] ;
  } else if ( index ===  0) {
    newTo = configClean[ longueur - 1] ;
  } else {
    newTo = configClean[index - 1 ] ;
  }
  dispatch(selectToWord(newTo));
};

const selectFromWord = (from) => async (dispatch, getState) => {
  const { mot, game } = getState();
  let { mots, loadingBank, bank } = mot;
  let { self, multi, write } = game;

  if (mots && mots.length > 1 && !_.isEmpty(from)) {
    if (loadingBank) {
      const { data } = await axios.post(configApp.URL_BACKEND + "/api/word/game/", { configId: from === 'image' ? 'image' : from._id, wordsIds: [mots[multi.randoms[multi.position]]._id] });
      multi.guess = _.head(data) ? _.head(data).t : '---';
    } else {
      let word = _.find(bank, function (o) { return o._id === mots[multi.randoms[multi.position]]._id });
      if (from === 'image') {
        multi.guess = word.image
      } else {
        let w = _.find(word.names, function (o) { return o.cid === from._id });
        multi.guess = w ? w.t : '---';
      }
    }
  }

  dispatch({ type: GAME_FROM, payload: from });
  dispatch({ type: GAME_MULTI, payload: multi });
  dispatch(setSelf(self));
  dispatch(setWrite(write));
};

const selectToWord = (to) => async (dispatch, getState) => {
  const { mot, game } = getState();
  let { mots, loadingBank, bank } = mot;
  let { self, multi, write } = game;

  if (mots && mots.length > 1 && !_.isEmpty(to)) {
    if (loadingBank) {
      const { data } = await axios.post(configApp.URL_BACKEND + "/api/word/game/", { configId: to._id, wordsIds: [mots[multi.randoms[multi.position]]._id] });
      multi.answer = _.head(data) ? _.head(data).t : '---';
    } else {
      let word = _.find(bank, function (o) { return o._id === mots[multi.randoms[multi.position]]._id });
      let w = _.find(word.names, function (o) { return o.cid === to._id });
      multi.answer = w ? w.t : '---';
    }
  }

  if (_.isEmpty(multi.choices)) {
    if (!multi.solution && mots && mots.length > 1 && !_.isEmpty(to)) {
      if (loadingBank) {
        let choices = genChoice(mots, multi.randoms[multi.position]).map(choice => mots[choice]._id);
        const { data } = await axios.post(configApp.URL_BACKEND + "/api/word/game/", { configId: to._id, wordsIds: choices });
        multi.choices = _.shuffle(data);
      } else {
        multi.choices = _.shuffle(genChoice(mots, multi.randoms[multi.position]).map(choice => mots[choice]._id).map(idMot => {
          let word = _.find(bank, function (o) { return o._id === idMot });
          let t = _.find(word.names, function (o) { return o.cid === to._id });
          return { i: word._id, t: t ? t.t : '---' }
        }));
      }
    }
  } else {
    if (loadingBank) {
      const { data } = await axios.post(configApp.URL_BACKEND + "/api/word/game/", { configId: to._id, wordsIds: multi.choices.map(o => o.i) });
      multi.choices = multi.choices.map(word => _.find(data, function (o) { return o.i === word.i }));
    } else {
      multi.choices = multi.choices.map(word => {
        let wordFound = _.find(bank, function (o) { return o._id === word.i });
        let t = _.find(wordFound.names, function (o) { return o.cid === to._id });
        return { i: wordFound._id, t: t ? t.t : '---' }
      });
    }
  }

  dispatch({ type: GAME_TO, payload: to });
  dispatch({ type: GAME_MULTI, payload: multi });
  dispatch(setSelf(self));
  dispatch(setWrite(write));
};

const toogle_from_to_word = (visible) => async (dispatch, getState) => {
  dispatch({ type: GAME_FROMTO_VISIBLE, payload: visible });
};

const chooseGame = (game) => async (dispatch, getState) => {
  dispatch({ type: GAME_CHOICE, payload: game });
};

const setSelf = (self) => async (dispatch, getState) => {
  const { mot, game } = getState();
  let { mots, loadingBank, bank } = mot;
  let { from, to } = game;
  if (mots && mots.length > 1 && !_.isEmpty(from)) {
    if (loadingBank) {
      const { data } = await axios.post(configApp.URL_BACKEND + "/api/word/game/", { configId: from === 'image' ? 'image' : from._id, wordsIds: [mots[self.randoms[self.position]]._id] });
      self.guess = _.head(data) ? _.head(data).t : '---';
    } else {
      let word = _.find(bank, function (o) { return o._id === mots[self.randoms[self.position]]._id });
      if (from === 'image') {
        self.guess = word.image
      } else {
        let w = _.find(word.names, function (o) { return o.cid === from._id });
        self.guess = w ? w.t : '---';
      }
    }
  }
  if (mots && mots.length > 1 && !_.isEmpty(to)) {
    if (loadingBank) {
      const { data } = await axios.post(configApp.URL_BACKEND + "/api/word/game/", { configId: to._id, wordsIds: [mots[self.randoms[self.position]]._id] });
      self.answer = _.head(data) ? _.head(data).t : '---';
    } else {
      let word = _.find(bank, function (o) { return o._id === mots[self.randoms[self.position]]._id });
      let w = _.find(word.names, function (o) { return o.cid === to._id });
      self.answer = w ? w.t : '---';
    }
  }
  dispatch({ type: GAME_SELF, payload: self });
};

const setWrite = (write) => async (dispatch, getState) => {
  const { mot, game } = getState();
  let { mots, loadingBank, bank } = mot;
  let { from, to } = game;
  if (mots && mots.length > 1 && !_.isEmpty(from)) {
    if (loadingBank) {
      const { data } = await axios.post(configApp.URL_BACKEND + "/api/word/game/", { configId: from === 'image' ? 'image' : from._id, wordsIds: [mots[write.randoms[write.position]]._id] });
      write.guess = _.head(data) ? _.head(data).t : '---';
    } else {
      let word = _.find(bank, function (o) { return o._id === mots[write.randoms[write.position]]._id });
      if (from === 'image') {
        write.guess = word.image;
      } else {
        let w = _.find(word.names, function (o) { return o.cid === from._id });
        write.guess = w ? w.t : '---';
      }
    }
  }
  if (mots && mots.length > 1 && !_.isEmpty(to)) {
    if (loadingBank) {
      const { data } = await axios.post(configApp.URL_BACKEND + "/api/word/game/", { configId: to._id, wordsIds: [mots[write.randoms[write.position]]._id] });
      write.answer = _.head(data) ? _.head(data).t : '---';
    } else {
      let word = _.find(bank, function (o) { return o._id === mots[write.randoms[write.position]]._id });
      let w = _.find(word.names, function (o) { return o.cid === to._id });
      write.answer = w ? w.t : '---';
    }
  }
  dispatch({ type: GAME_WRITE, payload: write });
};

const setAttempt = (multi) => async (dispatch, getState) => {
  dispatch({ type: GAME_MULTI, payload: multi });
};

const setMulti = (multi) => async (dispatch, getState) => {
  const { mot, game } = getState();
  let { mots, loadingBank, bank } = mot;
  let { from, to } = game;
  if (mots && mots.length > 1 && !_.isEmpty(from)) {
    if (loadingBank) {
      const { data } = await axios.post(configApp.URL_BACKEND + "/api/word/game/", { configId: from === 'image' ? 'image' : from._id, wordsIds: [mots[multi.randoms[multi.position]]._id] });
      multi.guess = _.head(data) ? _.head(data).t : '---';
    } else {
      let word = _.find(bank, function (o) { return o._id === mots[multi.randoms[multi.position]]._id });
      if (from === 'image') {
        multi.guess = word.image
      } else {
        let w = _.find(word.names, function (o) { return o.cid === from._id });
        multi.guess = w ? w.t : '---';
      }
    }
  }

  if (mots && mots.length > 1 && !_.isEmpty(to)) {
    if (loadingBank) {
      const { data } = await axios.post(configApp.URL_BACKEND + "/api/word/game/", { configId: to._id, wordsIds: [mots[multi.randoms[multi.position]]._id] });
      multi.answer = _.head(data) ? _.head(data).t : '---';
    } else {
      let word = _.find(bank, function (o) { return o._id === mots[multi.randoms[multi.position]]._id });
      let w = _.find(word.names, function (o) { return o.cid === to._id });
      multi.answer = w ? w.t : '---';
    }
  }

  if (!multi.solution) {
    multi.choices = [];
    if (!multi.solution && mots && mots.length > 1 && !_.isEmpty(to)) {
      if (loadingBank) {
        let choices = genChoice(mots, multi.randoms[multi.position]).map(choice => mots[choice]._id);
        const { data } = await axios.post(configApp.URL_BACKEND + "/api/word/game/", { configId: to._id, wordsIds: choices });
        multi.choices = _.shuffle(data);
      } else {
        multi.choices = _.shuffle(genChoice(mots, multi.randoms[multi.position]).map(choice => mots[choice]._id).map(idMot => {
          let word = _.find(bank, function (o) { return o._id === idMot });
          let t = _.find(word.names, function (o) { return o.cid === to._id });
          return { i: word._id, t: t ? t.t : '---' }
        }));
      }
    }
  }
  dispatch({ type: GAME_MULTI, payload: multi });
};

const setGame = () => async (dispatch, getState) => {
  const { mot, game } = getState();
  let { mots, loadingBank, bank } = mot;
  let { self, multi, write, from, to } = game;

  let alreadyNumber = [];
  for (let index = 0; index < mots.length; index++) {
    let chose = getNumber(mots.length - 1, alreadyNumber);
    alreadyNumber.push(chose);
  }

  //fetch the word to find
  let guess = '';
  if (mots && mots.length > 1 && !_.isEmpty(from)) {
    if (loadingBank) {
      const { data } = await axios.post(configApp.URL_BACKEND + "/api/word/game/", { configId: from === 'image' ? 'image' : from._id, wordsIds: [mots[alreadyNumber[0]]._id] });
      guess = _.head(data) ? _.head(data).t : '---';
    } else {
      let word = _.find(bank, function (o) { return o._id === mots[alreadyNumber[0]]._id });
      if (from === 'image') {
        guess = word.image;
      } else {
        let w = _.find(word.names, function (o) { return o.cid === from._id });
        guess = w ? w.t : '---';
      }
    }
  }

  let answer = '';
  if (mots && mots.length > 1 && !_.isEmpty(to)) {
    if (loadingBank) {
      const { data } = await axios.post(configApp.URL_BACKEND + "/api/word/game/", { configId: to._id, wordsIds: [mots[alreadyNumber[0]]._id] });
      answer = _.head(data) ? _.head(data).t : '---';
    } else {
      let word = _.find(bank, function (o) { return o._id === mots[alreadyNumber[0]]._id });
      let w = _.find(word.names, function (o) { return o.cid === to._id });
      answer = w ? w.t : '---';
    }
  }

  self.randoms = alreadyNumber;
  self.solution = false;
  self.position = 0;
  self.guess = guess;
  self.answer = answer;

  multi.randoms = alreadyNumber;
  multi.solution = false;
  multi.position = 0;
  multi.attempt = -1;
  multi.guess = guess;
  multi.answer = answer;

  write.randoms = alreadyNumber;
  write.solution = false;
  write.position = 0;
  write.guess = guess;
  write.answer = answer;

  //generate list of choice
  multi.choices = [];
  if (!multi.solution && mots && mots.length > 1 && !_.isEmpty(to)) {
    if (loadingBank) {
      let choices = genChoice(mots, alreadyNumber[0]).map(choice => mots[choice]._id);
      const { data } = await axios.post(configApp.URL_BACKEND + "/api/word/game/", { configId: to._id, wordsIds: choices });
      multi.choices = _.shuffle(data);
    } else {
      multi.choices = _.shuffle(genChoice(mots, alreadyNumber[0]).map(choice => mots[choice]._id).map(idMot => {
        let word = _.find(bank, function (o) { return o._id === idMot });
        let t = _.find(word.names, function (o) { return o.cid === to._id });
        return { i: word._id, t: t? t.t : '---' }
      }));
    }
  }

  dispatch({ type: GAME_SELF, payload: self });
  dispatch({ type: GAME_MULTI, payload: multi });
  dispatch({ type: GAME_WRITE, payload: write });
};

export {
  genereRandomNumber,
  getNumber,
  selectFromWord,
  selectToWord,
  toogle_from_to_word,
  chooseGame,
  setSelf,
  setMulti,
  setGame,
  setAttempt,
  setWrite,
  selectFromDecrement,
  selectFromIncrement,
  selectToDecrement,
  selectToIncrement
};
